// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from '@hey-api/client-fetch';
import type { LoginUserData, LoginUserResponses, LoginUserErrors, LogoutUserData, LogoutUserResponses, LogoutUserErrors, WhoAmIData, WhoAmIResponses, WhoAmIErrors, RequestPasswordResetData, RequestPasswordResetResponses, RequestPasswordResetErrors, ResetPasswordData, ResetPasswordResponses, ResetPasswordErrors, SetInitialPasswordData, SetInitialPasswordResponses, SetInitialPasswordErrors, GetAllCustomersData, GetAllCustomersResponses, GetAllCustomersErrors, CreateCustomerData, CreateCustomerResponses, CreateCustomerErrors, DeleteCustomerData, DeleteCustomerResponses, DeleteCustomerErrors, GetCustomerByIdData, GetCustomerByIdResponses, GetCustomerByIdErrors, UpdateCustomerData, UpdateCustomerResponses, UpdateCustomerErrors, SyncCartData, SyncCartResponses, SyncCartErrors, GetAllMachinesData, GetAllMachinesResponses, GetAllMachinesErrors, GetCustomerMachinesData, GetCustomerMachinesResponses, GetCustomerMachinesErrors, CreateMachineForCustomerData, CreateMachineForCustomerResponses, CreateMachineForCustomerErrors, DeleteMachineData, DeleteMachineResponses, DeleteMachineErrors, GetMachineByIdData, GetMachineByIdResponses, GetMachineByIdErrors, UpdateMachineData, UpdateMachineResponses, UpdateMachineErrors, UpdateMachineWeeklyChecklistDigestData, UpdateMachineWeeklyChecklistDigestResponses, UpdateMachineWeeklyChecklistDigestErrors, UpsertMachinePreviewData, UpsertMachinePreviewResponses, UpsertMachinePreviewErrors, UpsertMachineBomData, UpsertMachineBomResponses, UpsertMachineBomErrors, GetPreviewImageForItemData, GetPreviewImageForItemResponses, GetPreviewImageForItemErrors, UpsertInventoryPreviewData, UpsertInventoryPreviewResponses, UpsertInventoryPreviewErrors, GetHubspotCompanyByIdData, GetHubspotCompanyByIdResponses, GetHubspotCompanyByIdErrors, GetHubspotContactByIdData, GetHubspotContactByIdResponses, GetHubspotContactByIdErrors, GetAllLangguthUsersData, GetAllLangguthUsersResponses, GetAllLangguthUsersErrors, CreateLangguthUserData, CreateLangguthUserResponses, CreateLangguthUserErrors, DeleteLangguthUserData, DeleteLangguthUserResponses, DeleteLangguthUserErrors, GetLangguthUserByIdData, GetLangguthUserByIdResponses, GetLangguthUserByIdErrors, UpdateLangguthUserData, UpdateLangguthUserResponses, UpdateLangguthUserErrors, ResendLangguthUserInviteData, ResendLangguthUserInviteResponses, ResendLangguthUserInviteErrors, GetAllCustomerUsersData, GetAllCustomerUsersResponses, GetAllCustomerUsersErrors, GetAllCustomerUsersForCustomerData, GetAllCustomerUsersForCustomerResponses, GetAllCustomerUsersForCustomerErrors, CreateCustomerUserData, CreateCustomerUserResponses, CreateCustomerUserErrors, ResendCustomerUserInviteData, ResendCustomerUserInviteResponses, ResendCustomerUserInviteErrors, DeleteCustomerUserData, DeleteCustomerUserResponses, DeleteCustomerUserErrors, GetCustomerUserByIdData, GetCustomerUserByIdResponses, GetCustomerUserByIdErrors, UpdateCustomerUserData, UpdateCustomerUserResponses, UpdateCustomerUserErrors, GetAllRequestsData, GetAllRequestsResponses, GetAllRequestsErrors, GetAllRequestsForCustomerData, GetAllRequestsForCustomerResponses, GetAllRequestsForCustomerErrors, CreateRequestData, CreateRequestResponses, CreateRequestErrors, DeleteRequestData, DeleteRequestResponses, DeleteRequestErrors, GetRequestForCustomerByIdData, GetRequestForCustomerByIdResponses, GetRequestForCustomerByIdErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Login the user
 */
export const loginUser = <ThrowOnError extends boolean = false>(options?: Options<LoginUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<LoginUserResponses, LoginUserErrors, ThrowOnError>({
        url: '/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Logout the user
 */
export const logoutUser = <ThrowOnError extends boolean = false>(options?: Options<LogoutUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<LogoutUserResponses, LogoutUserErrors, ThrowOnError>({
        url: '/auth/logout',
        ...options
    });
};

/**
 * Get information about authentication status
 */
export const whoAmI = <ThrowOnError extends boolean = false>(options?: Options<WhoAmIData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<WhoAmIResponses, WhoAmIErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/auth/whoami',
        ...options
    });
};

/**
 * Request a password reset for a user
 */
export const requestPasswordReset = <ThrowOnError extends boolean = false>(options?: Options<RequestPasswordResetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RequestPasswordResetResponses, RequestPasswordResetErrors, ThrowOnError>({
        url: '/auth/password-reset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reset password using a reset token
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options?: Options<ResetPasswordData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
        url: '/auth/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Set initial password using a setup token
 */
export const setInitialPassword = <ThrowOnError extends boolean = false>(options?: Options<SetInitialPasswordData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SetInitialPasswordResponses, SetInitialPasswordErrors, ThrowOnError>({
        url: '/auth/set-initial-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get all customers
 */
export const getAllCustomers = <ThrowOnError extends boolean = false>(options?: Options<GetAllCustomersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllCustomersResponses, GetAllCustomersErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers',
        ...options
    });
};

/**
 * Create a new customer
 */
export const createCustomer = <ThrowOnError extends boolean = false>(options?: Options<CreateCustomerData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CreateCustomerResponses, CreateCustomerErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a customer
 */
export const deleteCustomer = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCustomerResponses, DeleteCustomerErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}',
        ...options
    });
};

/**
 * Get a customer by ID
 */
export const getCustomerById = <ThrowOnError extends boolean = false>(options: Options<GetCustomerByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCustomerByIdResponses, GetCustomerByIdErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}',
        ...options
    });
};

/**
 * Update a customer
 */
export const updateCustomer = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCustomerResponses, UpdateCustomerErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Synchronize the entire cart state (fire-and-forget tracking)
 */
export const syncCart = <ThrowOnError extends boolean = false>(options: Options<SyncCartData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SyncCartResponses, SyncCartErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}/cart/sync',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get all machines
 */
export const getAllMachines = <ThrowOnError extends boolean = false>(options?: Options<GetAllMachinesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllMachinesResponses, GetAllMachinesErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/machines',
        ...options
    });
};

/**
 * Get all machines for a customer
 */
export const getCustomerMachines = <ThrowOnError extends boolean = false>(options: Options<GetCustomerMachinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCustomerMachinesResponses, GetCustomerMachinesErrors, ThrowOnError>({
        url: '/customers/{customer_id}/machines',
        ...options
    });
};

/**
 * Create a new machine for a customer
 */
export const createMachineForCustomer = <ThrowOnError extends boolean = false>(options: Options<CreateMachineForCustomerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMachineForCustomerResponses, CreateMachineForCustomerErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}/machines',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a machine
 */
export const deleteMachine = <ThrowOnError extends boolean = false>(options: Options<DeleteMachineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMachineResponses, DeleteMachineErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/machines/{machine_id}',
        ...options
    });
};

/**
 * Get a machine by ID
 */
export const getMachineById = <ThrowOnError extends boolean = false>(options: Options<GetMachineByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMachineByIdResponses, GetMachineByIdErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/machines/{machine_id}',
        ...options
    });
};

/**
 * Update a machine
 */
export const updateMachine = <ThrowOnError extends boolean = false>(options: Options<UpdateMachineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateMachineResponses, UpdateMachineErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/machines/{machine_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update weekly checklist digest email settings for a machine
 */
export const updateMachineWeeklyChecklistDigest = <ThrowOnError extends boolean = false>(options: Options<UpdateMachineWeeklyChecklistDigestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateMachineWeeklyChecklistDigestResponses, UpdateMachineWeeklyChecklistDigestErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/machines/{machine_id}/weekly-checklist-digest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Upsert the preview image for a machine
 */
export const upsertMachinePreview = <ThrowOnError extends boolean = false>(options: Options<UpsertMachinePreviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpsertMachinePreviewResponses, UpsertMachinePreviewErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/machines/{machine_id}/preview',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Upsert the bill of materials for a machine
 */
export const upsertMachineBom = <ThrowOnError extends boolean = false>(options: Options<UpsertMachineBomData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpsertMachineBomResponses, UpsertMachineBomErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/machines/{machine_id}/bom',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get the preview image information for an inventory item
 */
export const getPreviewImageForItem = <ThrowOnError extends boolean = false>(options: Options<GetPreviewImageForItemData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPreviewImageForItemResponses, GetPreviewImageForItemErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/inventory/{as_mi_id}/preview',
        ...options
    });
};

/**
 * Upsert the preview image for an inventory item
 */
export const upsertInventoryPreview = <ThrowOnError extends boolean = false>(options: Options<UpsertInventoryPreviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpsertInventoryPreviewResponses, UpsertInventoryPreviewErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/inventory/{as_mi_id}/preview',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Get HubSpot company name by ID
 */
export const getHubspotCompanyById = <ThrowOnError extends boolean = false>(options: Options<GetHubspotCompanyByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetHubspotCompanyByIdResponses, GetHubspotCompanyByIdErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/company/{companyId}',
        ...options
    });
};

/**
 * Get HubSpot contact name by ID
 */
export const getHubspotContactById = <ThrowOnError extends boolean = false>(options: Options<GetHubspotContactByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetHubspotContactByIdResponses, GetHubspotContactByIdErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/contact/{contactId}',
        ...options
    });
};

/**
 * Get all Langguth users
 */
export const getAllLangguthUsers = <ThrowOnError extends boolean = false>(options?: Options<GetAllLangguthUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllLangguthUsersResponses, GetAllLangguthUsersErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/langguth/users',
        ...options
    });
};

/**
 * Create a new Langguth user
 */
export const createLangguthUser = <ThrowOnError extends boolean = false>(options?: Options<CreateLangguthUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CreateLangguthUserResponses, CreateLangguthUserErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/langguth/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a Langguth user
 */
export const deleteLangguthUser = <ThrowOnError extends boolean = false>(options: Options<DeleteLangguthUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteLangguthUserResponses, DeleteLangguthUserErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/langguth/users/{user_id}',
        ...options
    });
};

/**
 * Get a Langguth user by ID
 */
export const getLangguthUserById = <ThrowOnError extends boolean = false>(options: Options<GetLangguthUserByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLangguthUserByIdResponses, GetLangguthUserByIdErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/langguth/users/{user_id}',
        ...options
    });
};

/**
 * Update a Langguth user
 */
export const updateLangguthUser = <ThrowOnError extends boolean = false>(options: Options<UpdateLangguthUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateLangguthUserResponses, UpdateLangguthUserErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/langguth/users/{user_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resend new-user setup invite email
 */
export const resendLangguthUserInvite = <ThrowOnError extends boolean = false>(options: Options<ResendLangguthUserInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResendLangguthUserInviteResponses, ResendLangguthUserInviteErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/langguth/users/{user_id}/resend-invite',
        ...options
    });
};

/**
 * Get all customer users
 */
export const getAllCustomerUsers = <ThrowOnError extends boolean = false>(options?: Options<GetAllCustomerUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllCustomerUsersResponses, GetAllCustomerUsersErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/users',
        ...options
    });
};

/**
 * Get all customer users for a customer
 */
export const getAllCustomerUsersForCustomer = <ThrowOnError extends boolean = false>(options: Options<GetAllCustomerUsersForCustomerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAllCustomerUsersForCustomerResponses, GetAllCustomerUsersForCustomerErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}/users',
        ...options
    });
};

/**
 * Create a new customer user
 */
export const createCustomerUser = <ThrowOnError extends boolean = false>(options: Options<CreateCustomerUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateCustomerUserResponses, CreateCustomerUserErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resend new-user setup invite email
 */
export const resendCustomerUserInvite = <ThrowOnError extends boolean = false>(options: Options<ResendCustomerUserInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResendCustomerUserInviteResponses, ResendCustomerUserInviteErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}/users/{user_id}/resend-invite',
        ...options
    });
};

/**
 * Delete a customer user
 */
export const deleteCustomerUser = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomerUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCustomerUserResponses, DeleteCustomerUserErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/users/{user_id}',
        ...options
    });
};

/**
 * Get a customer user by ID
 */
export const getCustomerUserById = <ThrowOnError extends boolean = false>(options: Options<GetCustomerUserByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCustomerUserByIdResponses, GetCustomerUserByIdErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/users/{user_id}',
        ...options
    });
};

/**
 * Update a customer user
 */
export const updateCustomerUser = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomerUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCustomerUserResponses, UpdateCustomerUserErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/users/{user_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get all spare parts requests
 */
export const getAllRequests = <ThrowOnError extends boolean = false>(options?: Options<GetAllRequestsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllRequestsResponses, GetAllRequestsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/requests',
        ...options
    });
};

/**
 * Get all spare parts requests for a customer
 */
export const getAllRequestsForCustomer = <ThrowOnError extends boolean = false>(options: Options<GetAllRequestsForCustomerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAllRequestsForCustomerResponses, GetAllRequestsForCustomerErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}/requests',
        ...options
    });
};

/**
 * Create a new spare parts request for a customer
 */
export const createRequest = <ThrowOnError extends boolean = false>(options: Options<CreateRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateRequestResponses, CreateRequestErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}/requests',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a spare parts request
 */
export const deleteRequest = <ThrowOnError extends boolean = false>(options: Options<DeleteRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteRequestResponses, DeleteRequestErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/requests/{request_id}',
        ...options
    });
};

/**
 * Get a spare parts request for a customer by ID
 */
export const getRequestForCustomerById = <ThrowOnError extends boolean = false>(options: Options<GetRequestForCustomerByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRequestForCustomerByIdResponses, GetRequestForCustomerByIdErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'session_id',
                type: 'apiKey'
            }
        ],
        url: '/customers/{customer_id}/requests/{request_id}',
        ...options
    });
};